import { render, staticRenderFns } from "./PurchasedOrderReport.vue?vue&type=template&id=68a03d58&scoped=true"
import script from "./PurchasedOrderReport.vue?vue&type=script&lang=js"
export * from "./PurchasedOrderReport.vue?vue&type=script&lang=js"
import style0 from "./PurchasedOrderReport.vue?vue&type=style&index=0&id=68a03d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a03d58",
  null
  
)

export default component.exports